export var LABEL_COLORS_DEFAULT = {
  background: 'accent-negative-secondary',
  color: 'accent-negative-primary'
};
export var COUNTER_MAX_LENGTH_DEFAULT = 3;
export var SIZE_BY_DEVICE_TYPE = {
  desktop: 'S',
  tablet: 'M',
  phone: 'M'
};
export var TEST_ID = 'tabs';